import { actions } from "./action-list";

export function vehicleListFetched(value) {
  return {
    type: actions.FETCH_VEHICLE.FETCH_VEHICLE_LIST,
    value,
  };
}
export function contractType(value) {
  return {
    type: actions.CONTRACT_TYPE,
    value: value.contractType,
  };
}

export function updateRefreshUpliftStatus(value) {
  return {
    type: actions.REFRESH_UPLIFT,
    value,
  };
}

export function subscriptionPlanDetails(value) {
  return {
    type: actions.SUBSCRIPTION_PLAN_DETAILS,
    value,
  };
}

export function setContractStateData(value) {
  return {
    type: actions.CONTRACT_STATE_DATA,
    value,
  };
}

